module.exports = __webpack_public_path__ + "static/pizza22-43971b3ec7955dec18baaede5dfdb68c.webp";